import WebError from './WebError'

export default class NetworkError extends WebError {}